module.exports = __webpack_public_path__ + "static/media/0_2019_05_26-1.13a000c9.jpg";